import { Component, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective, ModalService } from 'mbs-ui-kit';
import { ProviderService } from 'mbs-ui-shared@services/provider.service';
import { TFAService } from 'mbs-ui-shared@services/tfa.service';

import { ReactiveFormsModule } from '@angular/forms';
import { catchError, finalize, noop, of } from 'rxjs';

@Component({
  selector: 'mbs-disable-password-recovery-modal-component',
  templateUrl: './disable-password-recovery-modal.component.html',
  imports: [ButtonComponent, CheckboxComponent, ReactiveFormsModule, ModalComponent, ModalFooterDirective]
})
export class DisablePasswordRecoveryModalComponent {
  private modalService = inject(ModalService);
  private providerService = inject(ProviderService);
  private TFAService = inject(TFAService);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public confirmControl = new FormControl(false);
  public loading = false;

  close = (): void => {
    this.baseModal.save();
  };
  dismiss = (): void => {
    this.baseModal.close();
  };

  handleDisable(): void {
    this.loading = true;
    this.providerService
      .setPasswordRecoveryState(false)
      .pipe(
        catchError((error) => of(error)),
        finalize(() => (this.loading = false))
      )
      .subscribe((result) => {
        if (result?.error?.authId) {
          this.showTFAModal(result.error);
        } else {
          this.baseModal.save();
        }
      });
  }

  showTFAModal(data) {
    this.TFAService.openApproveModal({ title: 'Disable Password Recovery', ...data })
      .then(() => {
        this.handleDisable();
      })
      .catch(noop);
  }
}
